import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-32f62a89")

_pushScopeId("data-v-32f62a89")
const _hoisted_1 = { class: "field" }
const _hoisted_2 = { class: "label" }
const _hoisted_3 = {
  key: 0,
  class: "label__text",
  for: "field"
}
const _hoisted_4 = {
  key: 1,
  class: "label__required"
}
const _hoisted_5 = {
  key: 0,
  class: "p-error"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_OSkeleton = _resolveComponent("OSkeleton")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        (_ctx.label)
          ? (_openBlock(), _createBlock("label", _hoisted_3, _toDisplayString(_ctx.label), 1))
          : _createCommentVNode("", true),
        (_ctx.invalidMessage)
          ? (_openBlock(), _createBlock("span", _hoisted_4, "*"))
          : _createCommentVNode("", true)
      ]),
      (!_ctx.loading)
        ? _renderSlot(_ctx.$slots, "default", {
            key: 0,
            id: "field"
          }, undefined, true)
        : (_openBlock(), _createBlock(_component_OSkeleton, {
            key: 1,
            height: "30px"
          }))
    ]),
    (_ctx.invalid)
      ? (_openBlock(), _createBlock("small", _hoisted_5, _toDisplayString(_ctx.invalidMessage), 1))
      : _createCommentVNode("", true)
  ]))
})